import { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const AuthContext = createContext(null);

// Attach stored token to every axios request automatically
const token = localStorage.getItem("admin_token");
if (token) axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;

export function AuthProvider({ children }) {
  const [admin, setAdmin] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const stored = localStorage.getItem("admin_token");
    if (!stored) { setLoading(false); return; }
    axios.defaults.headers.common["Authorization"] = `Bearer ${stored}`;
    axios.get(`${API}/auth/me`, { withCredentials: true })
      .then(res => setAdmin(res.data))
      .catch(() => { localStorage.removeItem("admin_token"); setAdmin(null); })
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const res = await axios.post(`${API}/auth/login`, { email, password }, { withCredentials: true });
    const tok = res.data.token;
    if (tok) {
      localStorage.setItem("admin_token", tok);
      axios.defaults.headers.common["Authorization"] = `Bearer ${tok}`;
    }
    setAdmin(res.data);
    return res.data;
  };

  const logout = async () => {
    try { await axios.post(`${API}/auth/logout`, {}, { withCredentials: true }); } catch {}
    localStorage.removeItem("admin_token");
    delete axios.defaults.headers.common["Authorization"];
    setAdmin(null);
  };

  return (
    <AuthContext.Provider value={{ admin, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
